import { type FieldValues, useController } from 'react-hook-form';
import type {
  FormControlProps,
  TypedUseControllerProps,
} from '../FormControl/FormControl.types';
import { TextField } from '../TextField/TextField';
import type { TextFieldProps } from '../TextField/TextField.types';

export type FormTextFieldProps<TFieldValues extends FieldValues = FieldValues> =
  TypedUseControllerProps<TFieldValues, string> &
    FormControlProps<TextFieldProps>;

export const FormTextField = <TFieldValues extends FieldValues = FieldValues>({
  disabled,
  ...props
}: FormTextFieldProps<TFieldValues>) => {
  const {
    field: { ref, ...field },
    fieldState: { error: fieldError },
  } = useController(props);

  const error = fieldError?.message?.toString();

  return (
    <TextField
      {...props}
      {...field}
      inputRef={ref}
      error={error}
      disabled={disabled}
    />
  );
};
